import React from "react";
import { SectionTop } from "../../..";

export default function AboutUs(props) {
	return (
		<section className="d-flex flex-column align-items-center justify-content-center no-px-md">
			<SectionTop heading="Welcome to HeadHeartHand" />

			<iframe
				width="90%"
				height="405"
				src="https://www.youtube.com/embed/tbnzAVRZ9Xc"
				title="YouTube video player"
				frameBorder="0"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
				allowFullscreen
			></iframe>
		</section>
	);
}
